import { Tree } from 'antd';
import type { TreeProps } from 'antd';

export interface DTreeProps extends TreeProps {}

export const DarwinTree = (props: DTreeProps) => {
  return <Tree {...props} />;
};
